import React from "react";
import CHCHandleSubmitComponent from "./runtimeComponent/summary/CHCHandleSubmitComponent";
import HandleSubmitComponent from "./runtimeComponent/summary/HandleSubmitComponent";
import { CHCOrderConfirmationComponent } from "./runtimeComponent/summary/CHCOrderConfirmationComponent";
import { ProgramContainer } from "./entities/formTemplateDataType";
// import { APPOrderConfirmationComponent } from "./runtimeComponent/summary/APPOrderConfirmationComponent";

const componentsMap = {
    CHCSubmit: CHCHandleSubmitComponent,
    Submit: HandleSubmitComponent,
    CHCConfirmation: CHCOrderConfirmationComponent,
    // APPConfirmation: APPOrderConfirmationComponent,
};

interface DynamicComponentProps {
  componentName: string; 
  componentProps: any; 
  onButtonClick?: (data) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callback?: (p: ProgramContainer) => void;
}

const DynamicComponent: React.FC<DynamicComponentProps> = ({ componentName, componentProps, onButtonClick ,callbackStepIndex, callback}) => {
  const ComponentToRender = componentsMap[componentName];

  return <ComponentToRender {...componentProps} onButtonClick={onButtonClick} callbackStepIndex={callbackStepIndex} callback={callback}/>;
};

export default DynamicComponent;
